module.exports = __webpack_public_path__ + "img/10.1dcdf93c.png";